module.exports = __webpack_public_path__ + "static/media/hud_background.abdbce09.svg";